<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ exam ? 'Update' : 'Add' }} Exam
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Exam Name">
          <d-input v-model="form.name" />
        </d-field>
        <d-field label="Exam Pass Percentage">
          <d-input v-model="form.passPercentage" type="text" placeholder="80" />
        </d-field>
        <d-field label="Allow retries">
          <input v-model="allowRetries" type="checkbox" />
        </d-field>
        <d-field label="Exam Passcode (optional)">
          <d-input v-model="form.password"/>
        </d-field>
        <d-field label="Description">
          <l-html-editor v-model="form.description" />
        </d-field>
        <p class="text-sm text-gray-800 mt-4 mb-4">
          You will be able to add questions once you save the basic exam information
        </p>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$emit('close')">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ exam ? 'Update' : 'Add' }} Exam
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import { createExam, updateExam } from '@resources/scripts/services/examsApi.service';
  import { toast } from '@services/toast.service';

  export default {
    props: {
      contentListing: {
        type: Object,
        default: () => ({}),
      },

      exam: {
        type: Object,
        default: null,
      },
    },

    emits: ['close', 'saved'],

    data() {
      return {
        saving: false,
        form: {
          name: '',
          description: '',
          passPercentage: '80',
          allowMultipleAttempts: 'true',
          password: '',
        },
      };
    },

    computed: {
      allowRetries: {
        get() {
          return this.form.allowMultipleAttempts === 'true';
        },
        set(val) {
          this.form.allowMultipleAttempts = val ? 'true' : 'false';
        },
      },
    },

    mounted() {
      if (this.exam) {
        this.form = JSON.parse(JSON.stringify(this.exam));
      }
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          if (this.exam) {
            await updateExam(this.form.id, this.form);
          } else {
            await createExam(this.form, this.contentListing.id);
          }
          this.$emit('saved');
          this.$emit('close');
        } catch (error) {
          if (error.response?.data?.message) {
            toast.error(error.response.data.message);
          } else if (error.response?.data) {
            toast.error(error.response.data);
          } else {
            toast.error('An error occurred while saving the exam');
          }
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>